module.exports = __webpack_public_path__ + "static/mara_ward-9260082cbd7f74893d8291afcb8732f0.jpg";